<div class="mdl-info">
    <button *ngIf="!data?.disable_close" class="mdl-info__close" type="button" (click)="closeModal()">X</button>
    <img class="mdl-info__img" [src]="img" [alt]="data.icon">
    <h4 class="mdl-info__title">{{ data.title}} </h4>
    <p class="mdl-info__txt" [innerHTML]="data.text"> </p>
    <ng-container *ngIf="data.message" >
        <div class="mdl-info__msg" [ngClass]="{ 'mdl-info__msg': true, 'mdl-info__msg-link': data?.message?.type == 'link' }" >
            <ng-container *ngIf="data?.message?.type != 'link'; else link">
                <img class="msg-icon" [src]="imgMsg" [alt]="data.icon">
                <p class="msg-txt" [innerHTML]="data.message.text"></p>
            </ng-container>
            <ng-template #link>
                <img class="msg-icon msg-icon__link" [src]="imgMsg" [alt]="data.icon">
                <a class="msg-txt msg-txt__link" [href]="data?.message?.link" target="_blank">{{ data.message.text }} </a>
            </ng-template>
        </div>
    </ng-container>
    <ng-container *ngIf="data.text_extra">
        <p class="mdl-info__txt" [innerHTML]="data.text_extra"> </p>
    </ng-container>
    <ng-container *ngIf="data.text_button">
        <button 
            (click)="closeModal()"
            [disabled]="data.disable_close ?? false"
            class="btn btn--primary mdl-info__btn">
            {{ data.text_button }}
        </button>
    </ng-container>
</div>